// extracted by mini-css-extract-plugin
export default {"PostContainer":"PostContainer_PostContainer__4sgNz","noPosts":"PostContainer_noPosts__uhJNY"};